import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import LecturerLessonAssignmentsApi from '../generated/api/LecturerLessonAssignments';

export default (service: Servicelayer) => ({
  ...LecturerLessonAssignmentsApi(service),

  // Add custom calls here

});
